var exports = {
  "K": "tokenList__w65Lup",
};

module.exports = exports;
